// frontend/src/components/common/MaintenanceChecker.js
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { API_URL } from '../../config';

/**
 * MaintenanceChecker component checks if maintenance mode is active
 * and redirects authenticated users to the maintenance page.
 */
const MaintenanceChecker = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useAuth();
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkMaintenanceMode = async () => {
      try {
        const response = await fetch(`${API_URL}/api/settings/public`);
        const data = await response.json();

        if (response.ok) {
          const isMaintenanceActive = data.data.maintenance_mode === true || data.data.maintenance_mode === 'true';
          setMaintenanceMode(isMaintenanceActive);

          // If maintenance mode is active and user is logged in
          // Dev users are exempt from maintenance mode redirects
          if (isMaintenanceActive && currentUser && currentUser.role !== 'dev') {
            // Don't redirect if already on maintenance page or settings page
            if (location.pathname !== '/maintenance' && location.pathname !== '/settings') {
              navigate('/maintenance', { replace: true });
            }
          }

          // If maintenance mode is off and user is on maintenance page, redirect to dashboard
          if (!isMaintenanceActive && location.pathname === '/maintenance' && currentUser) {
            navigate('/dashboard', { replace: true });
          }
        }
      } catch (error) {
        console.error('Error checking maintenance mode:', error);
      } finally {
        setLoading(false);
      }
    };

    checkMaintenanceMode();

    // Check maintenance mode every 30 seconds
    const interval = setInterval(checkMaintenanceMode, 30000);

    return () => clearInterval(interval);
  }, [currentUser, location.pathname, navigate]);

  // Don't block rendering, just handle redirects in the background
  return children;
};

export default MaintenanceChecker;
